
import Layout from '../components/Layout';
import { Shield, AlertTriangle, Ban, UserMinus, MessageSquare, Users } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Moderation = () => {
  const moderationFeatures = [
    {
      icon: <Shield className="h-8 w-8 text-fembot-pink" />,
      title: "Auto Moderation",
      description: "Set up automated moderation rules to filter spam, inappropriate content, and unwanted messages without manual intervention."
    },
    {
      icon: <AlertTriangle className="h-8 w-8 text-fembot-pink" />,
      title: "Warning System",
      description: "Issue and track warnings for users who break server rules with customizable thresholds for automated actions."
    },
    {
      icon: <Ban className="h-8 w-8 text-fembot-pink" />,
      title: "Temporary Bans",
      description: "Set up timed bans to automatically unban users after a specified duration, perfect for minor infractions."
    },
    {
      icon: <UserMinus className="h-8 w-8 text-fembot-pink" />,
      title: "Kick & Ban Management",
      description: "Easily manage server kicks and bans with detailed logs and reason tracking for accountability."
    },
    {
      icon: <MessageSquare className="h-8 w-8 text-fembot-pink" />,
      title: "Chat Filters",
      description: "Create custom word filters with exceptions, wildcard support, and automated response actions."
    },
    {
      icon: <Users className="h-8 w-8 text-fembot-pink" />,
      title: "Mod Logs",
      description: "Keep a detailed audit trail of all moderation actions taken on your server for transparency and accountability."
    }
  ];

  return (
    <Layout>
      <div className="py-24 bg-gradient-to-b from-white to-pink-50 dark:from-gray-800 dark:to-gray-900">
        <div className="container-custom">
          <div className="text-center mb-16">
            <div className="inline-block p-3 rounded-full bg-fembot-pink/10 mb-4">
              <Shield className="h-10 w-10 text-fembot-pink" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4 dark:text-white">
              Powerful <span className="text-fembot-pink">Moderation</span> Tools
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Keep your Discord server safe and well-managed with our comprehensive moderation features
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {moderationFeatures.map((feature, index) => (
              <div key={index} className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg transition-all hover:shadow-xl hover:-translate-y-1 duration-300">
                <div className="bg-fembot-pink/10 rounded-full p-3 w-16 h-16 flex items-center justify-center mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold mb-2 dark:text-white">{feature.title}</h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4">{feature.description}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-white dark:bg-gray-800 rounded-xl p-8 shadow-xl">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div>
                <h3 className="text-2xl font-bold mb-2 dark:text-white">Enhanced Moderation with Premium</h3>
                <p className="text-gray-600 dark:text-gray-400">
                  Upgrade to Premium for advanced moderation features, auto-mod rule customization, and more detailed logs.
                </p>
              </div>
              <Button 
                className="bg-gradient-to-r from-fembot-pink to-fembot-dark-pink hover:from-fembot-dark-pink hover:to-fembot-pink text-white px-6 py-3"
                onClick={() => window.location.href = '/premium'}
              >
                <Shield className="mr-2 h-5 w-5" />
                Upgrade Now
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Moderation;
